const routes = {
  HOME: '/',
  // Horses section
  HORSES_HOME: '/horses/',
  HORSES: '/hastarna/',
  NEWS: '/nyheter/',
  FACILITY: '/anlaggningen/',
  TEAM: '/teamet/',
  SERVICES: '/tjanster/',
  CONTACT: '/kontakt/',
  // Carting section
  CARTING_HOME: '/carting/',
  // Other
  DARNIT: '/404/',
} as const;

export default routes;
